const toBase64 = (file: File) =>
  new Promise(resolve => {
    const reader = new FileReader()
    reader.onload = (event: any) => resolve(event.target.result)
    return reader.readAsDataURL(file)
  })

export default toBase64
